import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-397cecb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "df both-side",
  style: {"position":"relative"}
}
const _hoisted_2 = { style: {"height":"calc(100vh - 275px)"} }
const _hoisted_3 = {
  class: "df",
  style: {"justify-content":"flex-end"}
}

import { reactive, ref, inject, toRaw, computed } from "vue";
import { DownOutlined } from "@ant-design/icons-vue";
import { Toast, debounce, timeStampToTime } from "@/utils";
import { useTable } from "@/views/notice/serve/table";
import { machineType, prototypeMachineStatus, loDepartment } from "./options";
import { machineTypeOption } from "./machieType.js";
import {
  getPrototypeRegistrationList,
  deletePrototypeRegistration,
  exportPrototype,
  syncDingtalkPrototype,
} from "@/request/view/prototypeManagement";
import machineForm from "./info.vue";
import machineMap from "./map/index.vue";
import locationForm from "./locationForm.vue";
import extensionForm from "./extension.vue";
import useDetailsForm from "./useDetailsForm.vue";
import staff from "@/components/chooseStaff/staffName.vue";
import departmentSelct from "./componemt/departmentSelct.vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'table',
  setup(__props) {

const activeKey: any = inject("activeKey");

const {
  requestConfig,
  table,
  requestPayload,
  initPayload,
  getListData,
  deleteRecords,
  hanldeUpdatePageNum,
} = useTable();

const machineFormRef = ref();
const machineMapRef = ref();
const locationFormRef = ref();
const extensionFormRef = ref();
const useDetailsFormRef = ref();

requestConfig.pull_fn = getPrototypeRegistrationList;
requestConfig.delete_fn = deletePrototypeRegistration;

console.log(useRoute());

const route = useRoute();

const deleteAuthory = computed(() => route.meta['/delete_prototype'] === true);

initPayload({
  applicant: null,
  applicantDept: null,
  lineNum: 10,
  lt3Days: null,
  pageNum: 1,
  prototypeSerial: null,
  prototypeType: null,
  prototypeModel: null,
  status: null,
});

const machineStatus = ref();
const machineStatusOptions = reactive([]);

const prototypeModelOptions = computed(() => {
  const f = machineTypeOption.find((f) => f.value === requestPayload.prototypeType);
  return f?.children || [];
});

const machineValue = ref([]);

const setDefaultStatus = () => {
  const type = activeKey.value;
  machineStatus.value = null;
  machineStatusOptions.length = 0;
  switch (type) {
    case "trialPrototype":
      requestPayload.status = "1,2,3";
      break;
    case "trialEnds":
      requestPayload.status = "5";
      break;
    case "prototypeForSale":
      requestPayload.status = "4";
      break;
    default:
      break;
  }

  const hasStatus = requestPayload.status.split(",");

  machineStatusOptions.push(
    ...prototypeMachineStatus.filter((f) => hasStatus.includes(String(f.value)))
  );
};

setDefaultStatus();

const departemnt = [];

loDepartment.forEach((item) => {
  departemnt.push({
    label: item,
    value: item,
  });
});

const rowKey = ref([]);

const rowSelection = {
  onChange: (selectedRowKeys) => {
    rowKey.value = selectedRowKeys;
  },
};

const columns = [
  {
    title: "客户类型",
    dataIndex: "trialCustomerType",
    align: "center",
    width: "120px",
    fixed: "left",
  },
  {
    title: "客户信息",
    dataIndex: "customerReceiptDetails",
    align: "center",
    width: "280px",
    fixed: "left",
  },
  { title: "设备类型", dataIndex: "prototypeType", align: "center", width: "120px" },
  { title: "设备型号", dataIndex: "prototypeModel", align: "center", width: "160px" },
  { title: "机身号", dataIndex: "prototypeSerial", align: "center", width: "180px" },
  {
    title: "设备状态",
    dataIndex: "status",
    align: "center",
    width: "100px",
    slots: {
      customRender: "status",
    },
  },
  { title: "试用天数", dataIndex: "trialDays", align: "center", width: "100px" },
  { title: "剩余天数", dataIndex: "remainingDays", align: "center", width: "100px" },
  { title: "创建时间", dataIndex: "createTime", align: "center", width: "120px" },
  { title: "过期时间", dataIndex: "expiresDate", align: "center", width: "120px" },
  {
    title: "申请人",
    dataIndex: "applicant",
    align: "center",
    width: "100px",
    slots: { customRender: "applicant" },
  },
  { title: "申请部门", dataIndex: "applicantDept", align: "center", width: "145px" },
  { title: "申请人电话", dataIndex: "applicantPhone", align: "center", width: "125px" },
  {
    title: "激活时间",
    dataIndex: "activationTime",
    align: "center",
    width: "120px",
    slots: { customRender: "activationTime" },
  },
  {
    title: "同步时间",
    dataIndex: "syncTime",
    align: "center",
    slots: { customRender: "syncTime" },
    width: "180px",
  },
  {
    title: "设备位置",
    dataIndex: "gpsLocation",
    align: "center",
    width: "240px",
  },
  { title: "配件", dataIndex: "prototypeAccessory", align: "center", width: "180px" },
  { title: "备注", dataIndex: "notes", align: "center", width: "220px" },
  {
    title: "操作",
    align: "center",
    slots: { customRender: "action" },
    fixed: "right",
    with: "120px",
  },
];

const handleInsertMachine = () => {
  machineFormRef.value.showModal("insert", { title: "样机管理" });
};

const handleUpdateMachine = (data) => {
  machineFormRef.value.showModal("update", { title: "样机管理", data });
};

const handleDeleteMachine = () => {
  deleteRecords(toRaw(rowKey.value), { title: "确认删除？" }).then(() => {
    getListData();
  });
};

const filter = (inputValue, path) => {
  return path.some((option) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
};

const handleDepartmentUpdate = (e) => {
  requestPayload.applicantDept = e;
  handleSearch();
};

const handleSelectPrototypeType = () => {
  requestPayload.prototypeType = machineValue.value[machineValue.value.length - 1];
  handleSearch();
};

const handleTypeChange = (e) => {
  if (!e) requestPayload.prototypeModel = null;
  table.pageNum = 1;
  handleSearch();
};

const handleSelectStatus = () => {
  if (!machineStatus.value) {
    setDefaultStatus();
    getListData();
    return;
  }
  requestPayload.status = machineStatus.value;
  getListData();
};

const handleMenuButton = (e, record) => {
  const { key } = e;
  switch (key) {
    case "manageLocation":
      locationFormRef.value.showModal(record.id);
      break;
    case "lookLocation":
      machineMapRef.value.showModal(record);
      break;
    case "extension":
      extensionFormRef.value.showModal(record);
      break;
    case "useDetails":
      useDetailsFormRef.value.showModal(record.id);
      break;
    default:
      break;
  }
};

const loading = ref(false);

const getData = () => {
  loading.value = true;
  getListData()
    .then(() => {
      loading.value = false;
    })
    .catch(() => {
      loading.value = false;
    });
};

const handleSearch = debounce(() => {
  requestPayload.pageNum = 1;
  table.pageNum = 1;
  getData();
}, 10);

const handleDownLoadMachine = () => {
  exportPrototype(rowKey.value).then((res: any) => {
    const link = document.createElement("a");
    const blob = new Blob([res], { type: "application/vnd.ms-excel" });
    link.style.display = "none";
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", `样机信息.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
};

const handlePageChange = (page, size) => {
  rowKey.value.length = 0;
  hanldeUpdatePageNum(page, size);
};

const showSizeChange = (page, size) => {
  hanldeUpdatePageNum(page, size);
};

const handleSelectStaff = (e) => {
  const { staffUserName } = e;
  const staff = staffUserName[0];
  requestPayload.applicant = staff ? staff : null;
  requestPayload.pageNum = 1;
  table.pageNum = 1;
  getData();
};

const useSyncButton = ref(true);

const handleSyncPrototype = async () => {
  try {
    useSyncButton.value = false;
    const data = await syncDingtalkPrototype();
    useSyncButton.value = true;
    if (!data || !data.code || !data.message) return Toast("warning", "同步失败", 3);
    const type = data.code === 200 ? "success" : "warning";
    Toast(type, data.message, 3);
    getData();
  } catch (error) {
    useSyncButton.value = true;
  }
};

getData();

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_space, null, {
        default: _withCtx(() => [
          _createVNode(staff, {
            staff: _unref(requestPayload).applicant,
            onGetChooseStaff: handleSelectStaff,
            appointDepartment: _unref(loDepartment)
          }, null, 8, ["staff", "appointDepartment"]),
          _createVNode(departmentSelct, { onHandleSearch: handleDepartmentUpdate }),
          _createVNode(_component_a_select, {
            value: _unref(requestPayload).prototypeType,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(requestPayload).prototypeType) = $event)),
            onChange: handleTypeChange,
            placeholder: "设备类型",
            allowClear: "",
            options: _unref(machineTypeOption),
            style: {"width":"100px"}
          }, null, 8, ["value", "options"]),
          _createVNode(_component_a_select, {
            value: _unref(requestPayload).prototypeModel,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(requestPayload).prototypeModel) = $event)),
            onChange: _unref(handleSearch),
            placeholder: "设备型号",
            allowClear: "",
            options: prototypeModelOptions.value,
            style: {"width":"140px"}
          }, null, 8, ["value", "onChange", "options"]),
          _createVNode(_component_a_select, {
            value: _unref(requestPayload).lt3Days,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(requestPayload).lt3Days) = $event)),
            onChange: _unref(handleSearch),
            placeholder: "小于3天",
            allowClear: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select_option, { value: true }, {
                default: _withCtx(() => [
                  _createTextVNode("是")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "onChange"]),
          (_unref(activeKey) === 'trialPrototype')
            ? (_openBlock(), _createBlock(_component_a_select, {
                key: 0,
                value: machineStatus.value,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((machineStatus).value = $event)),
                onChange: handleSelectStatus,
                placeholder: "样机状态",
                options: machineStatusOptions,
                style: {"width":"190px"},
                allowClear: ""
              }, null, 8, ["value", "options"]))
            : _createCommentVNode("", true),
          _createVNode(_component_a_input, {
            value: _unref(requestPayload).prototypeSerial,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(requestPayload).prototypeSerial) = $event)),
            onChange: _unref(handleSearch),
            placeholder: "样机机身号",
            allowClear: ""
          }, null, 8, ["value", "onChange"]),
          _createVNode(_component_a_input, {
            value: _unref(requestPayload).customerReceiptDetails,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(requestPayload).customerReceiptDetails) = $event)),
            onChange: _unref(handleSearch),
            placeholder: "客户信息",
            allowClear: ""
          }, null, 8, ["value", "onChange"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_space, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "primary",
            size: "small",
            onClick: handleInsertMachine
          }, {
            default: _withCtx(() => [
              _createTextVNode("新增")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            size: "small",
            onClick: handleDownLoadMachine,
            disabled: rowKey.value.length === 0
          }, {
            default: _withCtx(() => [
              _createTextVNode("导出")
            ]),
            _: 1
          }, 8, ["disabled"]),
          (deleteAuthory.value)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "danger",
                size: "small",
                onClick: handleDeleteMachine,
                disabled: rowKey.value.length === 0
              }, {
                default: _withCtx(() => [
                  _createTextVNode("删除")
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_a_button, {
        type: "primary",
        disabled: !useSyncButton.value,
        onClick: handleSyncPrototype,
        style: {"position":"absolute","right":"0px","top":"-50px"},
        size: "small"
      }, {
        default: _withCtx(() => [
          _createTextVNode("同步")
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_table, {
        scroll: { x: 2920, y: 'calc( 100vh - 340px )' },
        class: "margin-space",
        "data-source": _unref(table).data,
        bordered: "",
        pagination: false,
        "row-selection": rowSelection,
        columns: columns,
        rowKey: "id",
        loading: loading.value
      }, {
        activationTime: _withCtx(({ record }) => [
          _createElementVNode("span", null, _toDisplayString(record.activationTime ? _unref(timeStampToTime)(record.activationTime, "upload") : "-"), 1)
        ]),
        syncTime: _withCtx(({ record }) => [
          _createElementVNode("span", null, _toDisplayString(record.syncTime ? _unref(timeStampToTime)(record.syncTime, "seconds") : "-"), 1)
        ]),
        applicant: _withCtx(({ record }) => [
          _createElementVNode("span", null, _toDisplayString(record.applicant.split(",")[0]), 1)
        ]),
        status: _withCtx(({ record }) => [
          _createElementVNode("span", null, _toDisplayString(_unref(prototypeMachineStatus).find((v) => v.value === record.status)?.label), 1)
        ]),
        action: _withCtx(({ record }) => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_dropdown, null, {
                overlay: _withCtx(() => [
                  _createVNode(_component_a_menu, {
                    onClick: ($event: any) => (handleMenuButton($event, record))
                  }, {
                    default: _withCtx(() => [
                      (_unref(activeKey) !== 'prototypeForSale')
                        ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "extension" }, {
                            default: _withCtx(() => [
                              _createTextVNode("样机延期")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_menu_item, { key: "manageLocation" }, {
                        default: _withCtx(() => [
                          _createTextVNode("定位管理")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, { key: "lookLocation" }, {
                        default: _withCtx(() => [
                          _createTextVNode("查看定位")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, { key: "useDetails" }, {
                        default: _withCtx(() => [
                          _createTextVNode("使用情况")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 操作 "),
                      _createVNode(_unref(DownOutlined))
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_a_button, {
                type: "link",
                size: "small",
                onClick: ($event: any) => (handleUpdateMachine(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("编辑")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["scroll", "data-source", "loading"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_pagination, {
        class: "margin-space",
        size: "small",
        total: _unref(table).total,
        "show-total": (total) => `共 ${total} 条`,
        pageSize: _unref(table).lineNum,
        "onUpdate:pageSize": _cache[6] || (_cache[6] = ($event: any) => ((_unref(table).lineNum) = $event)),
        current: _unref(table).pageNum,
        "onUpdate:current": _cache[7] || (_cache[7] = ($event: any) => ((_unref(table).pageNum) = $event)),
        onChange: handlePageChange,
        onShowSizeChange: showSizeChange,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '30', '50', '100']
      }, null, 8, ["total", "show-total", "pageSize", "current"])
    ]),
    _createVNode(machineForm, {
      ref_key: "machineFormRef",
      ref: machineFormRef,
      onHandleUpdateTable: getData
    }, null, 512),
    _createVNode(machineMap, {
      ref_key: "machineMapRef",
      ref: machineMapRef
    }, null, 512),
    _createVNode(locationForm, {
      ref_key: "locationFormRef",
      ref: locationFormRef
    }, null, 512),
    _createVNode(extensionForm, {
      ref_key: "extensionFormRef",
      ref: extensionFormRef,
      onHandleUpdateTable: getData
    }, null, 512),
    _createVNode(useDetailsForm, {
      ref_key: "useDetailsFormRef",
      ref: useDetailsFormRef
    }, null, 512)
  ]))
}
}

})